import styled from 'styled-components';

export const VideoStyled = styled.iframe`
  width: 520px;
  height: 297px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  @media only screen and (max-width: 600px) {
    width: 100%;
    height: 219px;
  }
`;

export const RowStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  &.bettween {
    justify-content: space-between;
  }
`;
